<template>
  <div class="medical">
    <headd></headd>
    <div class="medical_kv">
      <img src="../../static/otherpage/banner_5.png" class="hidden-xs" />
      <img
        src="../../static/otherpage/banner_5_m.png"
        class="hidden-lg hidden-md hidden-sm "
      />
    </div>

    <div class="medical_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_13.png" />
          </div>
          许可证办理
        </div>
      </div>
      <div class="medical_list row hidden-xs hidden-sm">
        <div
          class="col-lg-4 col-xs-12"
          v-for="(item, index) in erlei"
          :key="item.id"
        >
          <div class="medical_item_1">
            <div class="medical_icon">
              <img :src="item.iconpath" />
            </div>
            <div class="medical_title">{{ item.title }}</div>
            <div class="medical_desc">{{ item.subtitle }}</div>
            <div class="medical_price">
              <span>￥</span>{{ item.show_price }}
            </div>

            <div
              class="medical_btn"
              @click="
                goproductDetail(item.title, item.id, item.show_price, 2, index)
              "
            >
              立即办理
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-xs-6"
          v-for="(item, index) in sanlei"
          :key="item.id"
        >
          <div class="medical_item_1">
            <!-- <div class="medical_icon">
              <img
                src="https://cdn.mscyeserver.mscye.com/uploads/files/icon_13.png"
              />
            </div> -->
            <div class="medical_title">{{ item.title }}</div>
            <div class="medical_desc">{{ item.subtitle }}</div>
            <div class="medical_price">
              <span>￥</span>{{ item.show_price }}
            </div>

            <div class="medical_select" v-if="item.option_array.length > 1">
              <select>
                <option
                  v-for="(item_1, index) in item.option_array"
                  :key="index"
                  >{{ item.name }}</option
                >
              </select>
            </div>
            <div
              class="medical_select"
              v-if="item.otheroption_array.length > 1"
            >
              <select @change="bindPickerChange_2($event, index)">
                <option
                  v-for="(item_1, index) in item.otheroption_array"
                  :key="index"
                  >{{ item_1 }}</option
                >
              </select>
            </div>

            <div
              class="medical_btn"
              @click="
                goproductDetail(item.title, item.id, item.show_price, 3, index)
              "
            >
              立即办理
            </div>
          </div>
        </div>
      </div>

      <div class="medical_list hidden-lg hidden-md">
        <div
          class="medical_item_1"
          v-for="(item, index) in erlei"
          :key="item.id"
        >
          <div class="medical_icon">
            <img :src="item.iconpath" />
          </div>
          <div class="medical_title">{{ item.title }}</div>
          <div class="medical_desc">{{ item.subtitle }}</div>
          <div class="medical_price"><text>￥</text>{{ item.show_price }}</div>

          <div
            class="medical_btn"
            @click="
              goproductDetail(item.title, item.id, item.show_price, 2, index)
            "
          >
            立即办理
          </div>
        </div>
      </div>
      <div class="medical_list hidden-lg hidden-md">
        <div
          class="medical_item_2"
          v-for="(item, index) in sanlei"
          :key="item.id"
        >
          <div class="medical_title">{{ item.title }}</div>
          <div class="medical_desc">{{ item.subtitle }}</div>
          <div class="medical_price"><text>￥</text>{{ item.show_price }}</div>

          <div class="medical_select" v-if="item.option_array.length > 1">
            <select>
              <option
                v-for="(item_1, index) in item.option_array"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
          <div class="medical_select" v-if="item.otheroption_array.length > 1">
            <select @change="bindPickerChange_2($event, index)">
              <option
                v-for="(item_1, index) in item.otheroption_array"
                :key="index"
                >{{ item_1 }}</option
              >
            </select>
          </div>
          <div
            class="medical_btn"
            @click="
              goproductDetail(item.title, item.id, item.show_price, 3, index)
            "
          >
            立即办理
          </div>
        </div>
      </div>
    </div>

    <div class="medical_html container">
      <div class="html_p">一、医疗器械分类</div>
      <div class="html_n">
        第一类是风险程度低，实行常规管理可以保证其安全、有效的医疗器械，经营第一类医疗器械不需许可和备案。
      </div>
      <div class="html_n">
        第二类是具有中度风险，需要严格控制管理以保证其安全、有效的医疗器械。，
        经营第二类医疗器械实行备案管理，体外诊断试剂除外（备案凭证)。
      </div>
      <div class="html_n">
        第三类是具有较高风险，需要采取特别措施严格控制管理以保证其安全、有效的
        医疗器械，经营第三类医疗器械实行许可管理（许可证)。
      </div>
      <div class="html_p">二、医疗器械经营方式</div>
      <div class="html_n">
        1.批发，是指将医疗器械销售给具有资质的经营企业或者使用单位的医疗器械经营行为。
      </div>
      <div class="html_n">
        2.零售，是指将医疗器械直接销售给消费者的医疗器械经营行为。
      </div>
      <div class="html_p">三、医疗器械网络销售</div>
      <div class="html_n">
        1、从事医疗器械网络销售的企业，应当在取得相关医疗器械备案凭证或许可证，后向所在地区市级食品药品监督管理部门备案。（医疗器械网络销售备案）。
      </div>
      <div class="html_n">
        2、通过自建网站开展医疗器械网络销售的企业，应当同时依法取得《互联网药品信息服务资格证书》，并具备与其规模相适应的办公场所以及数据备份、故障恢复等技术条件。（互联网药品信息服务资格证书）卖这些，要提交《医疗器械经营许可证》。
      </div>
      <div class="html_n">
        <img src="../../static/otherpage/icon_19.png" />
      </div>
      <div class="html_p">四、什么是医疗器械？</div>
      <div class="html_n">
        医疗器械，是指直接或者间接用于人体的仪器、设备、器具、体外诊断试剂及校准物、材料以及其他类似或者相关的物品，包括所需要的计算机软件；其效用主要通过物理等方式获得，不是通过药理学、免疫学或者代谢的方式获得，或者虽然有这些方式参与但是只起辅助作用；其目的是：<br />1、疾病的诊断、预防、监护、治疗或者缓解；<br />2、损伤的诊断、监护、治疗、缓解或者功能补偿；<br />3、生理结构或者生理过程的检验、替代、调节或者支持；<br />4、生命的支持或者维持；<br />5、妊娠控制；<br />6、通过对来自人体的样本进行检查，为医疗或者诊断目的提供信息。
      </div>
      <div class="html_p">五、什么是体外诊断试剂</div>
      <div class="html_n">
        体外诊断试剂是指按医疗器械管理的体外诊断试剂，包括在疾病的预测、预防、诊断、治疗监测、预后观察和健康状态评价的过程中，用于人体样本体外检测的试剂、试剂盒、校准品、质控品等产品。可以单独使用，也可以与仪器、器具、
        设备或者系统组合使用。
      </div>
      <div class="html_n">
        用于血源筛查的体外诊断试剂和采用放射性核素标记的体外诊断试剂属于药品管理。
      </div>
      <div class="html_p">医疗器械分类目录</div>
      <div class="html_type">
        <div class="type_item">01有源手术器械</div>
        <div class="type_item">02无源手术器械</div>
        <div class="type_item">03神经和心血管手术器械</div>
        <div class="type_item">04骨科手术器械</div>
        <div class="type_item">05放射治疗器械</div>
        <div class="type_item">06医用成像器械</div>
        <div class="type_item">07医用诊察和监护器械</div>
        <div class="type_item">08呼吸、麻醉和急救器械</div>
        <div class="type_item">09物理治疗器械</div>
        <div class="type_item">10输血、透析和体外循环器械</div>
        <div class="type_item">11医疗器械消毒灭菌器械</div>
        <div class="type_item">12有源植入器械</div>
        <div class="type_item">13无源植入器械</div>
        <div class="type_item">14注输、护理和防护器械</div>
        <div class="type_item">15患者承载器械</div>
        <div class="type_item">16眼科器械</div>
        <div class="type_item">17口腔科器械</div>
        <div class="type_item">18妇产科、辅助生殖和避孕器械</div>
        <div class="type_item">19医用康复器械</div>
        <div class="type_item">20中医器械</div>
        <div class="type_item">21医用软件</div>
        <div class="type_item">22临床检验器械</div>
      </div>
    </div>
    <maybe :is_include="name"></maybe>
    <!-- <common-poup ref="mychild" :service="service2"></common-poup> -->
    <foot></foot>
  </div>
</template>

<script>
import { getyiliaoqixieCombo } from "./api/api"; //引入api里面定义的方法
import indextel from "../components/indextel.vue";
import maybe from "../components/maybe.vue";
import headd from "../components/head";
import foot from "@/components/foot";

export default {
  data() {
    return {
      name: "医疗器械许可",
      solgan: "医疗器械许可证办理",
      solgan_2: "更专业！更快速！",
      service: "医疗器械咨询",
      service2: "二类医疗器械备案",
      index: 0,
      otherindex_list: 0,
      otherindex: 0,
      otheroption_array: [],
      option_array: [],
      option_array_price: [],
      combos_info: {},
      option: "",
      otheroption: "",
      oldprice: 0,
      erlei: [],
      sanlei: [],
      oindex_1: 0,
      oindex_2: 0
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indextel,
    maybe,
    headd,
    foot
  },
  mounted() {
    this.ComboList();
  },
  methods: {
    btn_beian() {
      this.$refs.mychild.open();
    },
    async ComboList() {
      var _self = this;
      const res = await getyiliaoqixieCombo();
      _self.erlei = res.data.data.erlei;
      _self.sanlei = res.data.data.sanlei;
      //_self.otheroption = _self.sanlei[0].otheroption_array[0];
      // _self.combos_info = res.data.data
      // _self.otheroption_array = res.data.data.otheroption_array
      // _self.otheroption_array = ['请选择',..._self.otheroption_array]
      // _self.option_array_price = res.data.data.option_array
      // var array=[];
      // for(var i=0;i<res.data.data.option_array.length;i++){
      // 	array.push(res.data.data.option_array[i].option)
      // }
      // _self.option_array = array
      // _self.option_array = ['请选择',..._self.option_array]
      // _self.oldprice = res.data.data.show_price
    },
    bindPickerChange(e) {
      //console.log(e)
      var _self = this;
      var index = e.detail.value;
      console.log(index);
      var option = "";
      var optionprice = 0;
      if (index == 0) {
        optionprice = _self.oldprice;
        option = "";
      } else {
        optionprice = _self.option_array_price[index - 1].optionprice;
        option = _self.option_array_price[index - 1].option;
      }
      _self.index = e.detail.value;
      _self.combos_info.show_price = optionprice == 0 ? "面议" : optionprice;
      _self.option = option;
    },
    bindPickerChange_2(e, index) {
      var _self = this;
      var index_list = index;

      var index_item = e.target.selectedIndex;
      _self.otherindex = e.target.selectedIndex;
      if (index_list == 0) {
        _self.oindex_1 = e.target.selectedIndex;
        _self.oindex_2 = 0;
      }
      if (index_list == 1) {
        _self.oindex_1 = 0;
        _self.oindex_2 = e.target.selectedIndex;
      }

      //console.log(index_item, index_list);
      _self.otherindex_list = index_list;

      _self.otheroption =
        _self.sanlei[index_list].otheroption_array[index_item];
    },
    goproductDetail(title, id, price, type, index) {
      var _self = this;
      //   if (_self.option_array.length > 1) {
      //     if (_self.option == "") {
      //       uni.showToast({
      //         title: "请选择选项1",
      //         icon: "none"
      //       });
      //       return false;
      //     }
      //   }
      //   if (_self.otheroption_array.length > 1) {
      //     if (_self.otheroption == "" || _self.otheroption == "请选择") {
      //       uni.showToast({
      //         title: "请选择选项2",
      //         icon: "none"
      //       });
      //       return false;
      //     }
      //   }
      if (index == 0 && type == 3) {
        _self.otheroption =
          _self.sanlei[index].otheroption_array[_self.oindex_1];
      } else if (index == 1 && type == 3) {
        _self.otheroption =
          _self.sanlei[index].otheroption_array[_self.oindex_2];
      }
      var data = {
        uid: localStorage.getItem("userId"),
        comboid: id,
        option: _self.option,
        otheroption: _self.otheroption
      };
      //console.log(data);
      if (_self.combos_info.show_price == "面议") {
        //this.$refs.mychild.open();
      } else {
        this.$router.push({
          name: "orderpay",
          query: {
            uid: data.uid,
            comboid: data.comboid,
            option: data.option,
            otheroption: data.otheroption
          }
        });
      }
    }
  }
  //   onShow() {
  //     this.ComboList();
  //     this.$logindex();
  //   }
};
</script>

<style lang="less" scoped>
.container {
  //   margin: 30rpx 32rpx;
  //   width: 686rpx;
}

.medical {
  flex-direction: column;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    .container {
      padding: 0;
    }
  }

  .medical_kv {
    // width: 750rpx;
    // height: 809rpx;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .medical_recommd {
    flex-direction: column;
    @media (max-width: 991px) {
      width: 6.86rem;
    }
  }

  .medical_list {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 0.3rem;

    .medical_item_1 {
      padding: 0.4rem 0.35rem;
      height: 4.6rem;
      width: 100%;
      background: #f6fbff;
      border-radius: 0.12rem;
      flex-direction: column;
      align-items: center;
      display: flex;

      .medical_icon {
        width: 2.05rem;
        height: 1.36rem;
        margin-bottom: 0.15rem;

        image {
          width: 100%;
          height: 100%;
        }
      }

      .medical_title {
        font-size: 0.2rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.3rem;
        height: 0.6rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
      }

      .medical_desc {
        font-size: 0.16rem;
        color: #5e5e66;
        line-height: 0.15rem;
        margin-bottom: 0.17rem;
      }

      .medical_price {
        font-size: 0.3rem;
        font-weight: bolder;
        color: #ff545a;
        line-height: 0.67rem;
        margin-bottom: 0.17rem;

        span {
          font-size: 0.3rem;
        }
      }

      .medical_btn {
        cursor: pointer;
        width: 1.72rem;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.2rem;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #ffffff;
        background: #1395ff;
        border-radius: 0.2rem;
        justify-content: center;
        align-items: center;
      }
      .medical_select {
        width: 2.97rem;
        height: 0.6rem;
        background: url(../../static/otherpage/icon_14.png) no-repeat;
        background-size: 2.97rem 0.6rem;
        margin-bottom: 0.2rem;
        padding-left: 0.33rem;
        overflow: hidden;
        padding-right: 0.5rem;

        select {
          width: 100%;
          font-size: 0.2rem;
          height: 0.6rem;
          line-height: 0.6rem;
          color: #1395ff;
          border: 0;
          background: transparent;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }

        .picker {
          width: 100%;
          font-size: 0.24rem;
          line-height: 0.6rem;

          color: #1395ff;
        }
      }
    }

    .medical_item_2 {
      padding: 0.24rem;
      width: 2.8rem;
      height: auto;
      background: #f6fbff;
      border-radius: 0.12rem;
      flex-direction: column;
      align-items: center;
      margin-bottom: 0.3rem;

      .medical_title {
        font-size: 0.26rem;

        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.37rem;
        text-align: center;
      }

      .medical_desc {
        font-size: 0.22rem;

        color: #5e5e66;
        line-height: 0.3rem;
        margin-bottom: 0.17rem;
      }

      .medical_price {
        font-size: 0.48rem;

        font-weight: bolder;
        color: #ff545a;
        line-height: 0.67rem;
        margin-bottom: 0.17rem;

        text {
          font-size: 0.3rem;
        }
      }

      .medical_select {
        width: 2.3rem;
        height: 0.6rem;
        background: url(../../static/otherpage/icon_14.png) no-repeat;
        background-size: 2.97rem 0.6rem;
        margin-bottom: 0.2rem;
        padding-left: 0.33rem;
        overflow: hidden;
        padding-right: 0.34rem;

        picker {
          width: 100%;
        }

        .picker {
          width: 100%;
          font-size: 0.24rem;
          line-height: 0.6rem;

          color: #1395ff;
        }
      }

      .medical_btn {
        width: 1.72rem;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.2rem;
        color: #ffffff;
        background: url(../../static/otherpage/btn_172.png) no-repeat;
        background-size: 1.72rem 0.4rem;
        justify-content: center;
        align-items: center;
      }
    }
    @media (max-width: 991px) {
      width: 100%;
      justify-content: space-between;
      margin-bottom: 0.3rem;
      display: flex;

      .medical_item_1 {
        padding: 0.4rem 0.35rem;
        width: 6.86rem;
        height: auto;
        background: #f6fbff;
        border-radius: 0.12rem;
        flex-direction: column;
        align-items: center;

        .medical_icon {
          width: 2.05rem;
          height: 1.36rem;
          margin-bottom: 0.15rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .medical_title {
          font-size: 0.28rem;
          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.37rem;
        }

        .medical_desc {
          font-size: 0.26rem;
          color: #5e5e66;
          line-height: 0.3rem;
          margin-bottom: 0.17rem;
        }

        .medical_price {
          font-size: 0.48rem;
          font-weight: bolder;
          color: #ff545a;
          line-height: 0.67rem;
          margin-bottom: 0.17rem;

          span {
            font-size: 0.3rem;
          }
        }

        .medical_btn {
          width: 2.37rem;
          height: 0.6rem;
          line-height: 0.6rem;
          text-align: center;
          font-size: 0.24rem;
          color: #ffffff;
          background: #1395ff;
          border-radius: 0.3rem;
          justify-content: center;
          align-items: center;
        }
      }

      .medical_item_2 {
        padding: 0.24rem;
        width: 48%;
        height: auto;
        background: #f6fbff;
        border-radius: 0.12rem;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0.3rem;
        display: flex;

        .medical_title {
          font-size: 0.28rem;
          font-weight: bolder;
          color: #1b1c33;
          line-height: 0.37rem;
          text-align: center;
        }

        .medical_desc {
          font-size: 0.26rem;
          color: #5e5e66;
          line-height: 0.3rem;
          margin-bottom: 0.17rem;
        }

        .medical_price {
          font-size: 0.48rem;

          font-weight: bolder;
          color: #ff545a;
          line-height: 0.48rem;
          margin-bottom: 0.17rem;

          span {
            font-size: 0.3rem;
            line-height: 0.6rem;
          }
        }

        .medical_select {
          width: 2.37rem;
          height: 0.6rem;
          background: url(../../static/otherpage/icon_14.png) no-repeat;
          background-size: 2.37rem 0.6rem;
          margin-bottom: 0.3em;
          padding-left: 0.33rem;
          overflow: hidden;
          padding-right: 0.34rem;

          select {
            width: 100%;
            font-size: 0.2rem;
            height: 0.6rem;
            line-height: 0.6rem;
            color: #1395ff;
            border: 0;
            background: transparent;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
          }
        }

        .medical_btn {
          width: 2.37rem;
          height: 0.6rem;
          line-height: 0.6rem;
          text-align: center;
          font-size: 0.24rem;

          color: #ffffff;
          background: #1395ff;
          border-radius: 0.3rem;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }

  .medical_html {
    flex-direction: column;
    text-align: left;
    @media (max-width: 991px) {
      width: 6.86rem;
    }

    .html_p {
      font-size: 0.2rem;
      line-height: 0.25rem;
      margin-bottom: 0.2rem;
      font-weight: bolder;
      @media (max-width: 991px) {
        font-size: 0.3rem;
        line-height: 0.42rem;
      }
    }

    .html_n {
      font-size: 0.16rem;
      line-height: 0.25rem;
      text-indent: 0.32rem;
      margin-bottom: 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.26rem;
        line-height: 0.33rem;
      }

      img {
        width: 100%;
        @media (max-width: 991px) {
          margin-left: -0.32rem;
        }
      }
    }

    .html_type {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-bottom: 0.2rem;
      background: rgba(196, 196, 204, 0.1);
      align-items: center;
      border-top: 0.01rem solid #eeeeee;
      border-left: 0.01rem solid #eeeeee;

      .type_item {
        height: 0.6rem;
        font-size: 0.16rem;
        color: #1b1c33;
        line-height: 0.25rem;
        padding: 0.2rem 2%;
        width: 25%;
        border-right: 0.01rem solid #eeeeee;
        border-bottom: 0.01rem solid #eeeeee;
        align-items: center;
        @media (max-width: 991px) {
          width: 33.33%;
          font-size: 0.26rem;
          line-height: 0.3rem;
          padding: 0.2rem 2%;
          height: 1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/medical.vue